import React from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import ACButton from '../../atoms/ACButton';
import { getInternalBaseUrl, getIndicatorColor } from '../../common/global.js';

import styles from './RouteList.module.scss';

export default class RouteList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onCreateRoute = this.onCreateRoute.bind(this);
    this.onClickRoute = this.onClickRoute.bind(this);
  }

  onSelectRoute(routeId, productId) {
    this.props.onSelectRouteFunc(routeId, productId);
  }

  onClickRoute(routeId, productId) {
    this.onSelectRoute(routeId, productId);
  }

  onCreateRoute() {
    this.props.onCreateRouteFunc();
  }

  onChangeText(e) {
    this.reset();
    this.props.onSearchRouteFunc(e.target.value);
  }

  renderRoutes() {
    const routes = this.props.routes;
    if (isEmpty(routes)) return;

    return routes.map((r) => {
      return this.renderRoute(r);
    });
  }

  renderRoute(route) {
    if (!route) return;
    const r = this.props.route;
    const id = route.id || '';
    let productName = '';
    let productId = '';
    if (route.product && !isEmpty(route.product)) {
      productName = route.product.name;
      productId = route.product.id;
    }
    // A route can deliver components as well as carry a product, so name both. Titles come
    // from the snapshot aex stores on the route; the deep link stays keyed on the product,
    // which is the only thing the routes screen filters by.
    const componentNames = (route.components || []).map((c) => c && (c.title || c.id));
    const connectionName = [productName, ...componentNames].filter(Boolean).join(' + ');

    let gotToRouteUrl = getInternalBaseUrl().routes + '?id=' + id + '&productId=' + productId;
    let s = [styles.routeLististItem];
    if (route && route.id === r.id) {
      s.push(styles.selected);
    }

    let borderLeftStyle = `3px solid ${getIndicatorColor(route.status)}`;

    return (
      <ListItem
        className={s.join(' ')}
        // onClick={() => this.onClickRoute(route.id, route.productId)}
        key={route.id}
      >
        <div style={{ width: '100%', marginLeft: '5px', borderLeft: borderLeftStyle }}>
          <Link
            to={gotToRouteUrl}
            style={{ textDecoration: 'none', color: 'inherit', width: '100%', padding: '10px' }}
            onClick={() => this.onClickRoute(route.id, route.productId)}
          >
            <div className={styles.routeName}>{route.name}</div>
            <div>{connectionName}</div>
          </Link>
        </div>
      </ListItem>
    );
  }

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.header}>
            Route List
            <ACButton
              text={'Add'}
              icon={<AddCircleOutlineIcon key="iconAddRoute" />}
              key="btnAddRoute"
              onClickFunc={() => this.onCreateRoute()}
            />
          </div>
          <TextField
            id="simple-start-adornment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            placeholder="Search"
            className={styles.search}
            value={this.props.searchText}
            onChange={(e) => this.props.onChangeSearchTextFunc(e)}
          />
        </div>
        <div className={styles.bottom}>
          <List className={styles.routeList}>{this.renderRoutes()}</List>
        </div>
      </div>
    );
  }
}
